import { Skeleton } from 'antd';
import styled from 'styled-components';

export const TitleCard = styled.h3`
  margin: 0;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContentList = styled.div`
  position: relative; 
  &.withPadding {
    padding-right: 12px;
  }
  .ant-list {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .ant-list-pagination {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .ant-list-item {
    cursor: pointer;
    padding: 5px 0;
    transition: all 0.3s ease;
    &:hover {
      background: var(--neutral-4);
    }
  }
  .ant-list-item-meta-title {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .ant-list-item-meta-description {
    margin: 0;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const AvatarCustom = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
`;

export const StyledTableSkeleton = styled.section`
  background: #fafafa;
  margin-top: 5px;
`;

export const TableFade = styled.div`
  pointer-events: none;
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  mask-image: -webkit-gradient(linear,left top, left bottom,from(rgba(0,0,0,1)),to(rgba(0,0,0,0)));
  -webkit-mask-image: -webkit-gradient(linear,left top, left bottom,from(rgba(0,0,0,1)),to(rgba(0,0,0,0)));
  bottom: 24px;
  background: #fff;
  transform: rotate(180deg);
`;

export const StyledSkeletonInput = styled(Skeleton.Input)`
  width: 100% !important;

  .ant-skeleton-input {
    width: 100% !important;
    min-width: 100% !important;
  }
`;
